import { LiaWalletSolid } from 'react-icons/lia';
import usdt from '../../../assets/profile/tether.svg';
import { IoChevronDown } from 'react-icons/io5';
import { Disclosure } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import TokenBalance from './TokenBalance';
import { useWalletAddress } from '@/features/account-abstraction/hooks/useWalletAddress';
import config from '@/common/config';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import { TransferModal } from './TransferModal';
import React, { useState } from 'react';
import { useToast } from '@/components/toast/useToast';
import TooltipWrapper, { TriggerType } from '@/components/new-design/ToolTipWrapper';
import useWalletBalance from '@/hooks/useWalletBalance';
import { IoIosArrowRoundForward } from 'react-icons/io';
import TransactionsModal from '@/features/user-profile/components/TransactionsModal';
import { formatCurrency } from '@/pages/table/utils/utils';
import { FiCopy } from 'react-icons/fi';
import { formatWalletAddress } from '@/common/utils/utils';

const WalletBalance = () => {
  const { toast } = useToast();

  const [showTransferModal, setShowTransferModal] = useState(false);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const { walletAddress, isLoading: isLoadingWallet } = useWalletAddress();

  const { data: usdtBalance, isLoading } = useWalletBalance(walletAddress, config.contracts.usdt);

  const handleCopyToClipboard = () => {
    toast({ description: 'Copied to clipboard', variant: 'success' });
    return navigator.clipboard.writeText(walletAddress || '');
  };

  const handleShowTransaction = () => setShowTransactionModal(true);

  return (
    <>
      <Disclosure>
        {({ open }) => (
          <div className="flex w-full flex-col gap-4">
            <Disclosure.Button className="w-full">
              <div className="w-full rounded-full bg-phenom-border-glow p-[2px]">
                <div className="flex h-11 w-full items-center justify-center gap-3 rounded-full bg-ph-violet-dark align-middle">
                  <LiaWalletSolid size={20} className="text-ph-gray-evening" />

                  <div className="flex items-center gap-1">
                    {isLoadingWallet || isLoading ? (
                      <LoadingSpinner size="4" />
                    ) : (
                      <span className="font-manrope text-base font-semibold text-ph-gray-white">
                        {usdtBalance ? formatCurrency(Number(usdtBalance.displayBalance)) : '-'}
                      </span>
                    )}
                    <img src={usdt} alt="usdt" className="h-[22px] w-[22px]" />
                  </div>

                  <IoChevronDown
                    size={20}
                    className={twMerge('text-ph-gray-evening', open && 'rotate-180 transform')}
                  />
                </div>
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className="flex w-full flex-col gap-5 text-sm text-ph-gray-evening">
              <div className="flex w-full flex-col gap-2">
                <span>My Wallet</span>

                {walletAddress && (
                  <div className="align-center flex items-center gap-4">
                    <LiaWalletSolid size={20} className="w-[1.7em] text-ph-primary-violet" />

                    <p className="overflow-hidden overflow-ellipsis whitespace-nowrap text-ph-gray-white">
                      {formatWalletAddress(walletAddress)}
                    </p>
                    <TooltipWrapper content="Copy" fullDimensions={false} triggerType={TriggerType.HOVER}>
                      <FiCopy
                        size={20}
                        className="text-ph-gray-evening hover:cursor-pointer"
                        onClick={handleCopyToClipboard}
                      />
                    </TooltipWrapper>
                  </div>
                )}
              </div>
              <div
                className="flex cursor-pointer items-center gap-1 text-ph-primary-violet"
                onClick={handleShowTransaction}
              >
                <span className="font-manrope text-sm font-semibold">Transaction History</span>
                <IoIosArrowRoundForward className="h-5 w-5 pt-0.5" />
              </div>
              <hr className="border-ph-gray-baltic" />

              <div className="flex flex-col gap-2">
                <p className="text-sm">
                  You can use only <span className="text-ph-primary-violet">USDT on Polygon</span> to play at Phenom
                  Poker. This is your balance:
                </p>

                <TokenBalance tokenBalance={usdtBalance} tokenName="USDT" chain="Polygon" />
              </div>
              {/*TODO: uncoment this once the feature is ready*/}
              {/*<hr className="border-ph-gray-baltic" />*/}

              {/*<p className="text-sm">*/}
              {/*  We offer an instant swap of your stablecoins with the lowest fee*/}
              {/*</p>*/}

              {/*<TokenBalance*/}
              {/*  tokenBalance={usdtBalance as GetBalanceReturnType}*/}
              {/*  tokenName="TEST"*/}
              {/*  chain="Test"*/}
              {/*/>*/}

              {/*<TokenBalance*/}
              {/*  tokenBalance={usdtBalance as GetBalanceReturnType}*/}
              {/*  tokenName="TEST"*/}
              {/*  chain="Test"*/}
              {/*/>*/}

              {/*<Button type="button" fullWidth disabled>*/}
              {/*  Swap Now*/}
              {/*</Button>*/}
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
      <TransferModal
        open={showTransferModal}
        setClose={() => {
          setShowTransferModal(false);
        }}
        balance={usdtBalance ? formatCurrency(Number(usdtBalance.displayBalance)) : '-'}
      />
      {showTransactionModal && (
        <TransactionsModal onClose={() => setShowTransactionModal(false)} isOpen={showTransactionModal} />
      )}
    </>
  );
};

export default WalletBalance;
